import { cn } from '@/lib/utils';

interface SkeletonCardProps {
  className?: string;
  lines?: number;
}

export function SkeletonCard({ className, lines = 3 }: SkeletonCardProps) {
  return (
    <div
      data-testid="skeleton-card"
      className={cn('rounded-xl p-5', className)}
      style={{
        backgroundColor: 'var(--background)',
        border: '1px solid var(--border-soft)',
        boxShadow: 'var(--card-shadow)',
      }}
    >
      {/* Title skeleton */}
      <div
        className="skeleton mb-4 h-3 w-2/5 rounded-lg"
        aria-hidden="true"
      />

      {/* Content lines */}
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className="skeleton mb-2 h-3 rounded-lg"
          style={{ width: `${60 + Math.random() * 40}%` }}
          aria-hidden="true"
        />
      ))}
    </div>
  );
}

export function SkeletonTable({ rows = 5 }: { rows?: number }) {
  return (
    <div
      data-testid="skeleton-table"
      className="overflow-hidden rounded-xl"
      style={{
        backgroundColor: 'var(--background)',
        border: '1px solid var(--border-soft)',
        boxShadow: 'var(--card-shadow)',
      }}
    >
      {/* Header */}
      <div
        className="flex gap-4 px-4 py-2.5"
        style={{ backgroundColor: 'var(--background-muted)' }}
      >
        {[120, 200, 100, 80].map((width, i) => (
          <div
            key={i}
            className="skeleton h-3 rounded-lg"
            style={{ width: `${width}px` }}
            aria-hidden="true"
          />
        ))}
      </div>

      {/* Rows */}
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="flex gap-4 px-4 py-3"
          style={{
            borderBottom:
              i < rows - 1 ? '1px solid var(--border-soft)' : undefined,
          }}
        >
          {[120, 200, 100, 80].map((width, j) => (
            <div
              key={j}
              className="skeleton h-3 rounded-lg"
              style={{ width: `${width}px` }}
              aria-hidden="true"
            />
          ))}
        </div>
      ))}
    </div>
  );
}
